import React, { useState, useEffect, useCallback, useContext } from "react";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import useCommonQuery from "../../store/common/useCommonQuery";
import "./ServiceLink.css";
import ShareIcon from "@mui/icons-material/Share";
import LayoutToggle from "../../components/LayoutToggle/LayoutToggle";
import { variableContext } from "../../context/VariableContex";

function ServiceLink() {
  const history = useHistory();
  const { layoutMode } = useContext(variableContext);
  const isListView = layoutMode === "list";

  const [currentPage, setCurrentPage] = useState(0);
  const [allServiceLinks, setAllServiceLinks] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const { data: serviceLink, isLoading } = useCommonQuery.Get_service_link({
    limit: 25,
    offset: currentPage * 25,
  });

  const handleShare = async () => {
    try {
      await navigator.share({ url: "https://masterclick.in/service-link" });
    } catch (error) {}
  };

  useEffect(() => {
    if (serviceLink && serviceLink.data) {
      if (currentPage === 0) {
        setAllServiceLinks(serviceLink.data.results || []);
      } else {
        setAllServiceLinks((prev) => [...prev, ...(serviceLink.data.results || [])]);
      }
      if (serviceLink.data.results && serviceLink.data.results.length < 25) {
        setHasMore(false);
      }
      setLoadingMore(false);
    }
  }, [serviceLink, currentPage]);

  const handleScroll = useCallback(() => {
    if (loadingMore || !hasMore || isLoading) return;
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement || document.body;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      setLoadingMore(true);
      setCurrentPage((prev) => prev + 1);
    }
  }, [loadingMore, hasMore, isLoading]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <div className={`sl-page${isListView ? " online-service-list-dark" : ""}`}>

      {/* ── Single toolbar: [Home] [Online Service] [LayoutToggle] [Share] ── */}
      <div className="sl-toolbar">
        <div className="sl-toolbar-inner">

          {/* Home button */}
          <button className="sl-home-btn" onClick={() => history.push("/")} aria-label="Home">
            <HomeIcon className="sl-home-icon" />
          </button>

          {/* Online Service title */}
          <span className="sl-title">Online Service</span>

          {/* Layout Switch — exact Home Page component, uncontrolled */}
          <LayoutToggle size="sm" />

          {/* Share button */}
          <button className="sl-share-btn" onClick={handleShare} aria-label="Share">
            <ShareIcon className="sl-share-icon" />
          </button>

        </div>
      </div>

      {/* ── Content body ── */}
      <div className="sl-body">

        {isLoading && allServiceLinks.length === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "40px", width: "100%" }}>
            <CircularProgress size={30} className="sl-progress" />
          </Box>
        ) : (
          <div className={isListView ? "sl-list-body" : "sl-grid-body"}>
            {allServiceLinks?.map((item) => (
              <a
                key={item.id}
                href={item?.url || ""}
                style={{ textDecoration: "none", width: "100%" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {isListView ? (
                  /* ── LIST VIEW CARD ── */
                  <div className="sl-list-card">
                    <div className="sl-list-img-wrap">
                      {item.small_icon ? (
                        <img src={item.small_icon} alt={item.name} className="sl-list-img" />
                      ) : (
                        <ShareIcon className="sl-list-placeholder-icon" />
                      )}
                    </div>
                    <div className="sl-list-content">
                      <span className="sl-list-label">{item.name}</span>
                      <ArrowBackIcon className="sl-list-arrow" style={{ transform: "rotate(180deg)" }} />
                    </div>
                  </div>
                ) : (
                  /* ── GRID VIEW CARD ── */
                  <div className="sl-grid-card">
                    <div className="sl-grid-icon-wrap">
                      {item.small_icon ? (
                        <img
                          src={item.small_icon}
                          alt={item.name}
                          className="sl-grid-icon-img"
                        />
                      ) : (
                        <div className="sl-grid-icon-placeholder">
                          <ShareIcon sx={{ fontSize: "20px", color: "#999" }} />
                        </div>
                      )}
                    </div>
                    <Typography className="sl-grid-label">{item.name}</Typography>
                  </div>
                )}
              </a>
            ))}
          </div>
        )}

        {loadingMore && (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px", width: "100%", gap: "10px" }}>
            <CircularProgress size={24} className="sl-progress" />
            <Typography variant="body2" className="sl-status-text">Loading more links...</Typography>
          </Box>
        )}

        {!hasMore && allServiceLinks.length > 0 && (
          <Box sx={{ textAlign: "center", padding: "20px", width: "100%" }}>
            <Typography variant="body2" className="sl-status-text">No more links to load</Typography>
          </Box>
        )}
      </div>
    </div>
  );
}

export default ServiceLink;
